// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  font-family: ${(props) => props.theme.fonts.primaryFontBlackFamily};
  display: flex;
  justify-content: center;
  flex-direction: row;
  text-align: center;
  padding: 12px 0 0;
  align-items: center;

  &.social-media-links {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => `
      flex-direction:  ${props.theme.brandSpecificStyles.FOOTER.FOOTER_TOP_CANDIDATE_A_SOCIAL_LINKS_FLEX_DIRECTION_MOBILE};
          `}
    }
  }
  .social-media-label {
    margin-right: 16px;
    white-space: nowrap;
    font-family: ${(props) => props.theme.fonts.tertiaryUrbaneBold};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: ${(props) =>
        props.theme.brandSpecificStyles.FOOTER.FOOTER_TOP_CANDIDATE_A_SOCIAL_LINKS_PADDING};
    }
  }
  .social-media-icon {
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      ${(props) =>
        props.isFooterRedesignEnabled
          ? `
    width: 28px;
    height: 28px;
  `
          : ''}
    }

    width: ${(props) => props.theme.brandSpecificStyles.FOOTER_SOCIAL_ICONS_MOBILE_WIDTH};
    height: ${(props) => props.theme.brandSpecificStyles.FOOTER_SOCIAL_ICONS_MOBILE_HEIGHT};
  }
  .social-media-pallete {
    display: flex;
    justify-content: center;

    ul {
      display: inherit;
      li {
        margin-right: 9px;
      }
      li:last-child {
        margin-right: 0;
      }
    }
  }
  @media (min-width: 200px) and (max-width: 360px) {
    .social-media-pallete {
      ul > li {
        margin-right: 9px;
      }
    }
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    padding: 0;
    .social-media-icon {
      width: ${(props) => props.theme.brandSpecificStyles.FOOTER_SOCIAL_ICONS_MOBILE_WIDTH};
      height: ${(props) => props.theme.brandSpecificStyles.FOOTER_SOCIAL_ICONS_MOBILE_HEIGHT};
    }
    .social-media-pallete {
      padding: 15px 0px 0px 0px;
    }
    .social-media-pallete ul li {
      margin-right: 14px;
      @media ${(props) => props.theme.mediaQuery.large} {
        margin-right: 24px;
      }
    }
    .social-media-label {
      margin-top: 15px;
      margin-right: 16px;
      white-space: nowrap;
    }
  }

  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    ${(props) =>
      props.isFooterRedesignEnabled &&
      `width: auto;
      display: flex;
      flex-direction: column;

      align-items: flex-start;

      background-color: #FAFAFA;

      padding-left:12px;
       .social-media-label{
          color: #000;
          font-family: Nunito;
          font-size: 12px;
          font-style: normal;
          font-weight: 600;
          // line-height: 150%;
          text-transform: capitalize;
           padding: 8px 0;
       }
     .social-media-pallete {
      padding:0;
       ${
         !props.isNavigationFooter
           ? `
     padding-right:14px;
      `
           : ``
       }
    }
      .social-media-icon {
        width: 28px;
        height: 28px;
      }

      `}
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    .social-media-label {
      margin-top: 10px;
      margin-right: 16px;
      white-space: nowrap;
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    flex-direction: column;
    ${(props) => props.isFooterRedesignEnabled && `align-items: flex-start;`}
    padding: 0 0 5px 0;
    .social-media-pallete {
      padding: 15px 0px 0px 0px;
    }

    .social-media-label {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
      line-height: 1;
      margin-right: 0;
      white-space: nowrap;
      ${(props) =>
        props.isFooterRedesignEnabled &&
        `color: #000;
font-family: Nunito;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 150%; /* 21px */
letter-spacing: 0.14px;
text-transform: capitalize;
margin-top:0;
`}
    }
    .social-media-icon {
      ${(props) =>
        props.isFooterRedesignEnabled
          ? `
         width: 28px;
        height: 28px;
        `
          : `
          width: ${props.theme.brandSpecificStyles.FOOTER_SOCIAL_ICONS_DESKTOP_WIDTH};
      height: ${props.theme.brandSpecificStyles.FOOTER_SOCIAL_ICONS_DESKTOP_HEIGHT};

        `}
    }
  }
`;
